import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import { serviceConsumer } from "../../network/ServiceConsumer";
import Help from "../../Components/Help/Help";
import EventSite from "../EventSite/EventSite";
import { shortDay } from "../EventSite/eventSiteModel";
import { isEventToday, pageStateForEvent } from "../../helper/eventFeed";
import { inLateWindow } from "../../helper/lateEntries";
import { useDispatch } from "react-redux";
import { setConversionRate } from "../Register-Events/helper";

const FeiseannazViewEvent = () => {
  const [loading, setLoading] = useState(true);
  const [dancerdetails, setDancerDetails] = useState([]);
  const [eventProp, setEventProp] = useState()
  const [urlEventName, setUrlEventName] = useState("")
  const [collaborators, setCollaborators] = useState()

  const navigate = useNavigate();
  const { state, search } = useLocation();
  const searchParams = new URLSearchParams(search)
  const eventId = searchParams.get('id')
  const wrapperRef = useRef(null)
  const dispatch = useDispatch()

  //getting event details from passed values; a shared or typed link has no
  //router state, so fall back to the event's own dates once it has loaded.
  const event = state?.from || pageStateForEvent(eventProp && { ...eventProp, eventType: "Feiseanna" });

  useEffect(() => {
    wrapperRef.current?.scrollTo({ top: -50, behavior: 'smooth' });
    getInitialDetails()
  }, []);

  //button handlers
  const backToViewEvent = () => {
    localStorage.getItem("accessToken") ? navigate("/parent") : navigate("/");
  };

  const goToRegisgternow = () => {
    const urlEventName = eventProp?.name?.split(" ").join("+");
    if (localStorage.getItem("accessToken")) {
      navigate(`/register-dancers?id=${eventId}`, {
        state: { event: eventProp },
      });
    } else {
      storeOnRegisterClick(urlEventName, eventProp);//in local for redirection
      navigate("/login", { replace: true });
    }
  };

  const competitorClickHandler = () => {
    const urlEventName = eventProp?.name?.split(" ").join("+");
    if (localStorage.getItem("accessToken")) {
      navigate(`/competitors/${urlEventName}?id=${eventProp?._id}`, {
        state: { event: eventProp, from: event },
      });
    } else {
      storeOnCompetitorClick(urlEventName, eventProp)
      navigate("/login");
    }
  };


  const goToViewResult = () => {
    const urlEventName = eventProp?.name?.split(" ").join("+");
    // if (localStorage.getItem("accessToken")) {
    navigate(`/results/${urlEventName}?id=${eventId}`, { state: { event: eventProp } });
    // } else {
    //   storeOnResultClick(urlEventName)
    //   navigate("/login");
    // }
  };

  //to get event,collaborator and dancer data
  const getInitialDetails = async () => {
    try {
      setLoading(true);
      const eventUrl = localStorage.getItem("accessToken") ? `${process.env.REACT_APP_BASE_URL}/feis/${eventId}` : `${process.env.REACT_APP_BASE_URL}/feis/single/${eventId}`
      const eventResponse = await serviceConsumer('GET', eventUrl)
      const eventNameForUrl = eventResponse?.Feis?.name?.split(" ").join("+");
      setConversionRate(dispatch,eventResponse?.Feis?.usdExchangeRate)
      setUrlEventName(eventNameForUrl)
      setEventProp(eventResponse.Feis)
      document.title = `Feis.link - ${eventResponse?.Feis?.name}`;
      const collaboratorsUrl = `${process.env.REACT_APP_BASE_URL}/feis/collaborators/${eventId}`
      const collaboratorsResponse = await serviceConsumer('GET', collaboratorsUrl)
      setCollaborators(collaboratorsResponse.result)


      if (localStorage.getItem("accessToken")) {
        const dancerUrl = `${process.env.REACT_APP_BASE_URL}/feis/events/dancers/${eventId}`;
        const dancerResponse = await serviceConsumer("GET", dancerUrl);
        setDancerDetails(dancerResponse.result)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      navigate("pageNotFound", { replace: true })
    }
  };

  const storeOnRegisterClick = (urlEventName) => {
    localStorage.setItem("path", `/feis/${urlEventName}?id=${eventProp?._id}`);
    localStorage.setItem("eventId", eventProp?._id);
    localStorage.setItem("eventType", eventProp?.eventType);
    localStorage.setItem("from", "open");
  }

  const storeOnCompetitorClick = (urlEventName) => {
    localStorage.setItem("path", `/competitors/${urlEventName}?id=${eventProp?._id}`);
    localStorage.setItem("eventId", eventProp?._id);
    localStorage.setItem("eventType", eventProp?.eventType);
    localStorage.setItem("from", event);
    localStorage.setItem("isCompetitor", true);
  }

  const storeOnResultClick = (urlEventName) => {
    localStorage.setItem("path", `/feis/${urlEventName}?id=${eventProp?._id}`);
    localStorage.setItem("eventId", eventProp?._id);
    localStorage.setItem("from", "result");
    localStorage.setItem("eventType", eventProp?.eventType);
  }


  // the header's state pill and buttons, as on the dashboard's cards
  const today = isEventToday(eventProp && { ...eventProp, eventType: "Feiseanna" });
  // closed but still taking late entries (MC2 5a45d7e3); a feed card passes
  // "open" for a late event, the page's own dates decide it is late
  const late = (event === "open" && eventProp?.registrationState === "late") || ((event === "open" || today) && inLateWindow(eventProp));
  const actions = eventProp ? [
    event !== "upcoming" && { key: "counts", icon: "bar_chart", onClick: competitorClickHandler, label: "Competitors" },
    event === "upcoming" && {
      key: "register", icon: "how_to_reg", primary: true, disabled: true,
      label: eventProp?.opening_date ? `Registration opens ${shortDay(eventProp.opening_date)}` : "Registration not open yet",
    },
    event === "open" && { key: "register", icon: "how_to_reg", primary: true, label: "Register", onClick: goToRegisgternow },
    event === "result" && { key: "results", icon: "emoji_events", primary: true, label: "View results", onClick: goToViewResult },
    // the event day itself can still take late entries: results stay first
    event === "result" && late && { key: "register", icon: "how_to_reg", label: "Late entry", onClick: goToRegisgternow },
  ].filter(Boolean) : [];
  const signedIn = !!localStorage.getItem("accessToken");
  const familyDancers = event === "result" && signedIn ? (dancerdetails || []) : [];

  return (
    <div ref={wrapperRef}>
      {loading && <Loader />}
      {!loading && eventProp && (
        <EventSite
          event={eventProp}
          kind="feis"
          state={today ? "today" : late ? "late" : event}
          actions={actions}
          collaborators={collaborators}
          onBack={backToViewEvent}
          dancers={familyDancers.length > 0 && (
            <ul className="es-names">
              {familyDancers.map((d, i) => (
                <li key={d?.result?._id || i}>{[d?.result?.fname, d?.result?.lname].filter(Boolean).join(" ")}</li>
              ))}
            </ul>
          )}
        />
      )}
      <Help />
    </div>
  );
};

export default FeiseannazViewEvent;
